import React, { memo, useMemo } from 'react'
import { Table, Tag } from 'antd'

import {
    CAPACITY_STATUS_BG,
    CAPACITY_STATUS_COLORS,
} from '../capacity.constants'
import {
    buildTableRows,
    formatCapacityDate,
    getStatusLabel,
} from '../capacity.utils'
import styles from '../ProjectCapacityDashboard.module.css'

const CapacityTable = memo(({ users, rangeStart, rangeEnd }) => {
    const rows = useMemo(
        () => buildTableRows(users, rangeStart, rangeEnd),
        [users, rangeStart, rangeEnd]
    )

    const columns = useMemo(
        () => [
            {
                title: 'User',
                dataIndex: 'userName',
                key: 'userName',
                width: 160,
            },
            {
                title: 'Project',
                dataIndex: 'projectName',
                key: 'projectName',
                width: 140,
            },
            {
                title: 'Task Count',
                dataIndex: 'taskCount',
                key: 'taskCount',
                width: 110,
                align: 'center',
            },
            {
                title: 'Assigned Hours',
                dataIndex: 'assignedHours',
                key: 'assignedHours',
                width: 140,
                render: (value) => `${value} Hr`,
            },
            {
                title: 'Availability',
                dataIndex: 'availability',
                key: 'availability',
                width: 160,
                render: (status, record) => (
                    <Tag
                        style={{
                            color: CAPACITY_STATUS_COLORS[status],
                            background: CAPACITY_STATUS_BG[status],
                            border: `1px solid ${CAPACITY_STATUS_COLORS[status]}33`,
                            fontWeight: 600,
                            margin: 0,
                        }}
                    >
                        {record.availabilityLabel || getStatusLabel(status)}
                    </Tag>
                ),
            },
            {
                title: 'Free Date',
                dataIndex: 'freeDate',
                key: 'freeDate',
                render: (date) =>
                    date
                        ? `Available after ${formatCapacityDate(date)}`
                        : '—',
            },
        ],
        []
    )

    return (
        <section className={styles.tableSection}>
            <h3 className={styles.sectionTitle}>Detailed Breakdown</h3>
            <Table
                className={styles.capacityTable}
                columns={columns}
                dataSource={rows}
                pagination={false}
                size="middle"
                scroll={{ x: 900 }}
            />
        </section>
    )
})

CapacityTable.displayName = 'CapacityTable'

export default CapacityTable
